// Modules
import { ChangeEvent, useCallback } from "react";
import { useRouter } from "next/router";

// Redux
import { useAppDispatch } from "redux/hooks";
import { setSorting } from "redux/searchPage/showResults/showResultsSlice";

// Hooks
import useRouting from "hooks/useRouting";

// Constants
import { Sorting } from "constants/searchPage/gpoSearchEnum";
import { QueryStringPrimaryKeys } from "constants/searchPage/urlEnum";

// Utils
import {
	appendQueryStringParameterInUrl,
	checkIfQueryStringExists,
	removeSpecificKeyFromQueryString} from "utils/searchPage/queryString";

const useSearchResults = () => {
	const router = useRouter();
	const dispatch = useAppDispatch();
	const pushNewRoute = useRouting();

	const handleOnlyPurchaseCourse = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			let newQueryString;
			if (event.target.checked) {
				newQueryString = appendQueryStringParameterInUrl(
					router.query,
					{
						queryStringKey: QueryStringPrimaryKeys.AVAILABLE_PURCHASE_COURSES,
						queryStringValue: "true"
					},
					true
				);
			} else {
				newQueryString = removeSpecificKeyFromQueryString(router.query, QueryStringPrimaryKeys.AVAILABLE_PURCHASE_COURSES);
			}
			pushNewRoute(newQueryString);
		},
		[router]
	);

	const handleCourseSorting = useCallback(
		(event: ChangeEvent<HTMLSelectElement>) => {
			const sorting: Sorting = event.target.value as Sorting;
			dispatch(setSorting(sorting));
			const newQueryString = appendQueryStringParameterInUrl(router.query, {
				queryStringKey: QueryStringPrimaryKeys.SORT,
				queryStringValue: sorting
			});
			pushNewRoute(newQueryString);
		},
		[router]
	);

	const isPurchaseOnlyChecked = useCallback((): boolean => {
		return !!checkIfQueryStringExists(router.query, QueryStringPrimaryKeys.AVAILABLE_PURCHASE_COURSES);
	}, [router]);

	return {
		handleOnlyPurchaseCourse,
		handleCourseSorting,
		isPurchaseOnlyChecked
	};
};

export default useSearchResults;
